// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"b9b61056","321":"4a6616a3","473":"b9b61056"}[chunkId] + ".chunk.css";
};